import { ContentBlock } from "./contentBlock";
import { LinkType } from "./link";

export type ContactForm = {
    _type: 'contactForm';
    title: string;
    contactLinks?: LinkType[];
}


export const isContactForm = (block: ContentBlock): block is ContactForm => {
    return block._type === 'contactForm';
}
